import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterOlComment } from '../../../lib/types/models/center-ol-comment/center-ol-comment'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterOlComments(input: PaginationRequest & { centerId: number }) {
  const { centerId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.centers.getCenterOlComments.url, { centerId }),
        rest
      )
    )
    .get<PaginationResponse<CenterOlComment>>()
}
